module.exports = __webpack_public_path__ + "static/media/redcross.9c3e6dda.svg";